/* 🤖 this file was generated by svg-to-ts */
export const matIconSettingsAccessibility: {
  name: 'settings-accessibility';
  data: string;
} = {
  name: 'settings-accessibility',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20.5 4c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 6c1.86.5 4 .83 6 1v12h2v-6h2v6h2V7c2-.17 4.14-.5 6-1l-.5-2zM12 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2z"/></svg>`
};
